import gql from 'graphql-tag';

export default gql`
  mutation AUTH_SEND_EMAIL_ADDRESS_VERIFICATION_EMAIL($originUrl: String!) {
    authSendEmailAddressVerificationEmail(originUrl: $originUrl)
  }
`
